import tenantService from '@/services/api/tenant.service';
class Services {
  tenant = tenantService;
}

export default new Services();
